// extracted by mini-css-extract-plugin
module.exports = {"caseStudyWrap":"case-study_caseStudyWrap__3nPTJ"};